
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { List, Record } from 'immutable';

import Tile from '../../navigation/MobileNavigation/Tile';
import { PRODUCT_ROUTES, RACING_SPORTS } from '../../../constants';

import styles from './PopularSports.module.scss';

const PopularSports = ({
  tags,
  history,
  topFive,
  product,
  toggleNavigation,
  changeProduct
}) => {
  const productUrlPrefix = PRODUCT_ROUTES[product];

  const navigate = useCallback(({ url, product: productUpdate }) => {
    toggleNavigation(false);

    const timer = setTimeout(() => {
      if (productUpdate) {
        changeProduct(productUpdate);
      }

      history.push(url);
    }, 270);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  let topFiveSports = [];

  if (tags.size) {
    const liveBettingTag =
      tags.find(t => t.urlName === 'live-betting');

    topFiveSports = topFive.splice(3, 1).reduce((acc, item) => {
      const existingTag = tags.find(t => t.id === item.id);
      const { metaTags = [], url, urlName } = existingTag || new Record();
      const { url: firstSubMetaTagUrlName } = tags.find(t => t.uuid === metaTags[0]) || {};


      const setFirstCompetitionUrl = !RACING_SPORTS.includes(urlName) && metaTags.length === 1;

      if (existingTag) {
        return [
          ...acc,
          existingTag.set('url', setFirstCompetitionUrl ? firstSubMetaTagUrlName : url)
        ];
      }

      return acc;
    }, []);

    if (liveBettingTag) {
      topFiveSports.push(liveBettingTag.withMutations(mutatedTag => (
        mutatedTag.set('name', 'Live Betting')
      )));
    }
  }

  return (
    <div>
      <div className={styles.sectionHeader}>
        <span>
          Popular Sports
        </span>
      </div>
      <div className={styles.sectionContent}>
        {topFiveSports.map(({ urlName, id, name, url }) => (
          <Tile
            key={id}
            name={name}
            className={styles.sportTile}
            iconName={urlName}
            url={`${productUrlPrefix}/events${url}`}
            onClick={navigate}
            section={'popularSports'}
            showLabel
          />
        ))}
      </div>
    </div>
  );
};

PopularSports.propTypes = {
  topFive: PropTypes.instanceOf(List).isRequired,
  tags: PropTypes.instanceOf(List).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  product: PropTypes.string.isRequired,
  toggleNavigation: PropTypes.func.isRequired,
  changeProduct: PropTypes.func.isRequired,
};

export default PopularSports;
